import { render } from "./pin-details.vue?vue&type=template&id=4965f834&scoped=true&ts=true"
import script from "./pin-details.vue?vue&type=script&lang=ts"
export * from "./pin-details.vue?vue&type=script&lang=ts"

import "./pin-details.vue?vue&type=style&index=0&id=4965f834&lang=sass&scoped=true"

import exportComponent from "/Users/ohirjak/projects/mov-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4965f834"]])

export default __exports__